<div id="curved-column-chartdiv" style="width: 100%; height: 500px"></div>